<template>

  <div>
    <el-form :inline="true" :model="query" class="query-form" size="mini">

      <el-form-item class="query-form-item" label="任务名称">
        <el-input v-model="query.name" placeholder="任务名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button-group>
          <el-button type="primary" icon="el-icon-refresh" @click="onReset"></el-button>
          <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
          <el-button type="primary" @click.native="handleForm(null,null)">新增</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;">
      <el-table
          v-loading="loading"
          :data="list"
          style="width: 100%;">
        <el-table-column
            label="ID"
            prop="id"
            fixed>
        </el-table-column>
        <el-table-column
            label="任务名称"
            prop="name">
        </el-table-column>
        <el-table-column
            label="消息列表"
            prop="message_names">
            <template slot-scope="scope">
              <div>
                <div class="table-td-item" v-for="(item, index) in scope.row.message_names" :key="index">
                  {{item}}
                </div>
              </div>
            </template>
        </el-table-column>
        <el-table-column
            label="群组列表"
            prop="group_names">
            <template slot-scope="scope">
              <div>
                <div class="table-td-item" v-for="(item, index) in scope.row.group_names" :key="index">
                  {{item}}
                </div>
              </div>
            </template>
        </el-table-column>
        <el-table-column
            label="群组分类列表"
            prop="group_classify_names">
            <template slot-scope="scope">
              <div>
                <div class="table-td-item" v-for="(item, index) in scope.row.group_classify_names" :key="index">
                  {{item}}
                </div>
              </div>
            </template>
        </el-table-column>
        <el-table-column
            label="任务指令"
            prop="corn">
        </el-table-column>
        <el-table-column
            label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status | statusFilterType">{{ scope.row.status | statusFilterName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            width="180"
            label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time | parseTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
            width="180"
            label="更新时间">
          <template slot-scope="scope">
            <span>{{ scope.row.modified_time | parseTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" v-if="scope.row.status === 1" @click.native="submitStatus(scope.$index, scope.row, 0)">暂停
            </el-button>
            <el-button type="success" size="mini" v-else @click.native="submitStatus(scope.$index, scope.row, 1)">开启
            </el-button>
            <br>
            <div style="height: 5px;"></div>
            <el-button type="primary" size="mini" @click.native="handleSend(scope.$index, scope.row)">手动发送</el-button>
            <br>
            <el-button type="text" size="small" @click.native="handleForm(scope.$index, scope.row)">编辑
            </el-button>
            <el-button type="text" size="small" @click.native="handleDel(scope.$index, scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-scrollbar>

    <el-pagination
        :page-size="query.limit"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="total">
    </el-pagination>

    <!--表单-->
    <el-dialog
        :close-on-click-modal="false"
        :title="formMap[formName]"
        :visible.sync="formVisible"
        :before-close="hideForm"
        width="85%"
        top="5vh">
      <el-form :model="formData" :rules="formRules" ref="dataForm">
        <el-form-item label="任务名称" prop="name">
          <el-input v-model="formData.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="消息ID（多个用逗号隔开）" prop="message_id">
          <el-input v-model="formData.message_id" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="群组ID（多个用逗号隔开，此字段和群组分类只能选择一个）" prop="group_id">
          <el-input v-model="formData.group_id" :disabled="formData.group_classify_id.length > 0" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="群组分类ID（多个用逗号隔开，此字段和群组ID只能选择一个）" prop="group_classify_id">
          <el-input v-model="formData.group_classify_id" :disabled="formData.group_id.length > 0" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="定时任务指令" prop="corn">
          <a href="https://www.bejson.com/othertools/cron/">定时任务在线编辑</a>
          <el-input v-model="formData.corn" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio :label="0">暂停</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="hideForm">取消</el-button>
        <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import {groupJobDelete, groupJobList, groupJobSave, groupJobSend} from "../../api/group/groupJob";

const formJson = {
  id: "",
  name: "",
  message_id: "",
  group_id: "",
  group_classify_id: "",
  corn: "",
  status: 1,
};
export default {
  data() {
    return {
      query: {
        name: "",
        page: 1,
        limit: 20,
      },
      list: [],
      total: 0,
      loading: true,
      index: null,
      formName: null,
      formMap: {
        add: "新增",
        edit: "编辑"
      },
      formLoading: false,
      formVisible: false,
      formData: formJson,
      formRules: {
        name: [
          {required: true, message: "请输入任务名称", trigger: "blur"}
        ],
        status: [
          {required: true, message: "请选择状态", trigger: "change"}
        ]
      },
      deleteLoading: false,
      sendLoading: false,
    };
  },
  methods: {
    onReset() {
      this.$router.push({
        path: ""
      });
      this.query = {
        name: "",
        page: 1,
        limit: 20,
      };
      this.getList();
    },
    onSubmit() {
      this.$router.push({
        path: "",
        query: this.query
      });
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    getList() {
      this.loading = true;
      groupJobList(this.query)
          .then(response => {
            this.loading = false;
            if (response.code) {
              this.$message.error(response.message);
            }
            this.list = response.data.list || [];
            this.total = response.data.total || 0;
          })
          .catch(() => {
            this.loading = false;
            this.list = [];
            this.total = 0;
          });
    },
    // 隐藏表单
    hideForm() {
      // 更改值
      this.formVisible = !this.formVisible;
      return true;
    },
    // 刷新表单
    resetForm() {
      if (this.$refs["dataForm"]) {
        // 清空验证信息表单
        this.$refs["dataForm"].clearValidate();
        // 刷新表单
        this.$refs["dataForm"].resetFields();
      }
    },
    // 显示表单
    handleForm(index, row) {
      this.formVisible = true;
      this.formData = JSON.parse(JSON.stringify(formJson));
      if (row !== null) {
        this.formData = Object.assign({}, row);
      }
      this.formName = "add";
      if (index !== null) {
        this.index = index;
        this.formName = "edit";
      }
    },
    // 显示表单
    submitStatus(index, row, status) {
      row.status = status
      this.formLoading = true;
      let data = Object.assign({}, row);
      groupJobSave(data, this.formName).then(response => {
        this.formLoading = false;
        if (response.code) {
          this.$message.error(response.message);
          return false;
        }
        data.modified_time = new Date()
        this.list.splice(this.index, 1, data);
        this.getList()
        this.$message.success("操作成功");
      });
    },
    formSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.formLoading = true;
          let data = Object.assign({}, this.formData);
          groupJobSave(data, this.formName).then(response => {
            this.formLoading = false;
            if (response.code) {
              this.$message.error(response.message);
              return false;
            }
            if (this.formName === "add") {
              // 向头部添加数据
              if (response.data && response.data.id) {
                data.id = response.data.id;
                data.create_time = new Date()
                data.modified_time = new Date()
                this.list.unshift(data);
              }
            } else {
              data.modified_time = new Date()
              this.list.splice(this.index, 1, data);
              this.getList()
            }
            this.$message.success("操作成功");
            // 刷新表单
            this.resetForm();
            this.hideForm()
          });
        }
      });
    },
    // 删除
    handleDel(index, row) {
      if (row.id) {
        this.$confirm("确认删除该记录吗?", "提示", {
          type: "warning"
        })
            .then(() => {
              let para = {id: row.id};
              this.deleteLoading = true;
              groupJobDelete(para)
                  .then(response => {
                    this.deleteLoading = false;
                    if (response.code) {
                      this.$message.error(response.message);
                      return false;
                    }
                    this.$message.success("删除成功");
                    // 刷新数据
                    this.list.splice(index, 1);
                  })
                  .catch(() => {
                    this.deleteLoading = false;
                  });
            })
            .catch(() => {
              this.$message.error("取消删除");
            });
      }
    },
    // 手动发送
    handleSend(index, row) {
      if (row.id) {
        this.$confirm("确认发送吗?", "提示", {
          type: "warning"
        })
            .then(() => {
              let para = {id: row.id};
              this.sendLoading = true;
              groupJobSend(para)
                  .then(response => {
                    this.sendLoading = false;
                    if (response.code) {
                      this.$message.error(response.message);
                      return false;
                    }
                    this.$message.success("发送成功");
                  })
                  .catch(() => {
                    this.sendLoading = false;
                  });
            })
            .catch(() => {
              this.$message.error("取消发送");
            });
      }
    },
  },
  filters: {
    statusFilterType(status) {
      const statusMap = {
        0: "danger",
        1: "success",
      };
      return statusMap[status];
    },
    statusFilterName(status) {
      const statusMap = {
        0: "暂停",
        1: "开启",
      };
      return statusMap[status];
    },
  },
  mounted() {
  },
  created() {
    // 将参数拷贝进查询对象
    let query = this.$route.query;
    this.query = Object.assign(this.query, query);
    this.query.limit = parseInt(this.query.limit);
    // 加载表格数据
    this.getList();
  }
};
</script>

<style lang="less" scoped>
</style>
